module.exports = __webpack_public_path__ + "img/20211012_2.ac8ec0ab.jpg";